/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Results_Save_Prefix_AltInputs */

const en_onboarding_results_save_prefix_alt = /** @type {(inputs: Onboarding_Results_Save_Prefix_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save `)
};

const es_onboarding_results_save_prefix_alt = /** @type {(inputs: Onboarding_Results_Save_Prefix_AltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahorra `)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Onboarding_Results_Save_Prefix_AltInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_results_save_prefix_alt = /** @type {((inputs?: Onboarding_Results_Save_Prefix_AltInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Results_Save_Prefix_AltInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_results_save_prefix_alt(inputs)
	return en_onboarding_results_save_prefix_alt(inputs)
});